import { usePageScale } from "@/ui/usePageScale";

export const BASE_W = 1264 as const;

/**
 * 공통 헤더용 스케일 훅
 */
export function useScale() {
    const { r, s, px } = usePageScale({ baseW: BASE_W });
    return { r, s, px };
}
